import { render, staticRenderFns } from "./Promos.vue?vue&type=template&id=5c5d708e&scoped=true"
import script from "./Promos.vue?vue&type=script&lang=js"
export * from "./Promos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d708e",
  null
  
)

export default component.exports